<template>
  <div>
    <section class="searching-opponent">
      <div class="searching-opponent__content">
        <h1>{{ getTranslations.home_searching_opponent_searching_opponent }}</h1>
        <div class="searching-opponent__content__avatars">
          <div v-for="opponentAvatar in opponentsAvatars" :key="opponentAvatar" class="avatar-item"><img :src="opponentAvatar" alt=""></div>
        </div>
      </div>
    </section>
    <div class="square-loader">
      <svg width="100%" height="100%">
        <rect width="100%" height="100%" style="fill:rgba(0,0,0,0);stroke:#3eb080" />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { Howl } from 'howler';
import shuffle from 'knuth-shuffle-seeded';
import { squareLoaderAnimation, randomSearchAnimation } from '@/common/jQuery';

export default {
  name: 'searchingOpponentFreePlay',
  data() {
    return {
      timer: null,
      opponentsAvatars: [],
      searchSound: new Howl({
        src: ['/static/sounds/SearchForOpponent.ogg', '/static/sounds/SearchForOpponent.mp3'],
        loop: true,
      }),
    };
  },
  created() {
    // eslint-disable-next-line
    console.log('in SearchingOpponent free play created hook');
    // resetting game state
    this.resetGameState();
    this.setGameInProgress(true);
    for (let i = 1; i < 17; i += 1) {
      this.opponentsAvatars.push(`/static/images/avatar_${this.avatarGrouping.toString()}/Avatar_${i.toString()}.jpg`);
    }
    shuffle(this.opponentsAvatars, new Date());
  },
  mounted() {
    // eslint-disable-next-line
    console.log('in SearchingOpponent free play mounted hook');
    if (this.soundsOn) {
      this.searchSound.play();
    }
    this.findOpponent();
    squareLoaderAnimation();
    randomSearchAnimation(this);
    // fix animation on window resize
    // eslint-disable-next-line
    $(window).resize(() => squareLoaderAnimation());
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
      'setGameInProgress',
      'setPlayersDetails',
    ]),
    findOpponent() {
      this.setPlayersDetails({
        homePlayerMSISDN: 'trial user',
        homePlayerUsername: `${this.getTranslations.visitor_free_trial_player}#1`,
        homePlayerAvatar: '/static/images/avatar_default.svg',
        homePlayerLevel: 0,
        awayPlayerMSISDN: 'bot',
        awayPlayerUsername: `${this.getTranslations.visitor_free_trial_player}#2`,
        awayPlayerAvatar: '/static/images/avatar_default.svg',
        awayPlayerLevel: 0,
      });

      clearInterval(this.timer);
      this.normalTransition = true;
      this.searchSound.stop();
      // eslint-disable-next-line
      console.log('going to opponent found page...');
      setTimeout(() => {
        this.$router.replace('/trial/opponentFound');
      }, 5000);
    },
    showHideModal() {
      /* eslint-disable */
      $('.modal-close, .modal-overlay').click(() => {
        $('.modal, .modal-overlay').fadeOut();
        this.$router.push('/home');
      });

      $('.modal,.modal-overlay').fadeIn(200);
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'avatarGrouping',
      'soundsOn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/SearchingOpponentFreePlay.vue